export const data = [
  {
    education: "Certified Blockchain Associate",
    duration: "05/2019 - 06/2019",
    institute: "Kerala Blockchain Academy (KBA)",
    description: "Completed Certified Blockchain Associate Programme",
  },
  {
    education: "Certified Full Stack Developer",
    duration: "05/2019 - 06/2019",
    institute: "ICT Academy Of Kerala",
    description: "Completed Certified Full Stack Developer Programme",
  },
  {
    education: "Bachelor of Engineering - Mechatronics",
    duration: "08/2013 - 05/2017",
    institute: "Akshaya College of Engineering and Technology",
    description: "Graduated Mechatronics Engineering Degree with first class",
  },
];
